<template>
<section class="short-stay-section">
  <div class="tsa-container">
    <div class="tsa-flex-container">

      <ShortStay
        title="Conheça o Short-Stay, a solução de aluguel temporário."
        text="Seu imóvel aqui tem mais valor, afinal a short-stay agora também conta com imóveis de alto padrão."
        subText="Pensando em desocupar o seu imovel?"
        extraText="Deixa que a short-stay cuida dele para voce e ainda com retorno financeiro."
        buttonText="Veja opções de angariação Short-Stay"
        :dark="true"
        class="tsa-card-1 tsa-text-left"
        buttonClass="tsa-btn-main"
        :img="card1Image"
        
      >
      </ShortStay>

      <div class="tsa-side-container">

        <ShortStay
          title="Invista no futuro com imóveis de alto padrão"
          text="Imóveis com retorno financeiro imediato. Seu dinheiro parado no banco pode gerar muito mais retorno quando investido no lugar certo."
          buttonText="Ver imóveis para investir"
          class="tsa-card-2 tsa-text-left"
          cardClass="tsa-card-2"
          buttonClass="tsa-btn-secondary"
          :img="card2Image"
          
        />

        <ShortStay
          title="Explore os lançamentos triple A. imóveis de alto padrão novos e exclusivos"
          text="Mude para o extraordinário com imóveis que redefinem o conceito de luxo. Sua Oportunidade de viver com exclusividade está a um passo de deistância"
          class="tsa-card-3"
          cardClass="tsa-card-3 tsa-text-left"
          :img="card3Image"
          
        />
      </div>
    </div>
  </div>
</section>
</template>


<script>
import "@/assets/scss/custom/triplea/components/_short_stay_section.scss";
import ShortStay from './ShortStay.vue';
import card1Image from "@/assets/img/triplea/home/short-stay/card1-image.svg";
import card2Image from "@/assets/img/triplea/home/short-stay/card2-image.svg";
import card3Image from "@/assets/img/triplea/home/short-stay/card3-image.svg";

export default {
  components: {
    ShortStay,
  },
  data() {
    return {
      card1Image,
      card2Image,
      card3Image,
    };
  },
};
</script>

